// import ImagePerson from "@/components/functionals/ImagePerson";
import LinkDialogOpenerForReportByProduct from "@/components/requests/reports/reportByproductByMonth/LinkDialogOpenerForReportByProduct";

const columns = (thiss) => [
  {
    prop: "ProductDescription",
    label: "Producto",
    "min-width": 200,
    sortable: true,
    fixed: true
    // formatter: ImagePerson,
    // attrs: {
    //   imgKey: "ResponsiblePhoto"
    // }
    //formatter: HyperlinkForModuleVacations
  },

  // {
  //   prop: "TotalHours",
  //   label: "Horas",
  //   align: "center",
  //   "min-width": 100,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  {
    prop: "January",
    label: "Enero",
    align: "center",
    "min-width": 80,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    // formatter: (row, column, rowValue) => (
    //    <LinkDialogOpenerForReportByProduct rowValue={rowValue} row={row} column={column} call={thiss.OpenDialodDetailList} />
    // )
  },
  {
    prop: "February",
    label: "Febrero",
    align: "center",
    "min-width": 80,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "March",
    label: "Marzo",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "April",
    label: "Abril",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "May",
    label: "Mayo",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "June",
    label: "Junio",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "July",
    label: "Julio",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "August",
    label: "Agosto",
    align: "center",
    "min-width": 80,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "September",
    label: "Septiembre",
    align: "center",
    "min-width": 100,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "October",
    label: "Octubre",
    align: "center",
    "min-width": 80,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "November",
    label: "Noviembre",
    align: "center",
    "min-width": 100,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "December",
    label: "Diciembre",
    align: "center",
    "min-width": 100,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkDialogOpenerForReportByProduct, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "Total",
    label: "Total por producto",
    align: "center",
    fixed: "right",
    "min-width": 130
    // sortable: true,
    // formatter: (row, column, rowValue) => {
    //   const createElement = thiss.$createElement;
    //   return createElement(LinkDialogOpenerForReportByProduct, {
    //     props: {
    //       rowValue,
    //       row,
    //       column,
    //       call: thiss.OpenDialodDetailList
    //     }
    //   });
    // }
    //formatter: HyperlinkForModuleVacations
  }
  // {
  //   prop: "OverallProductivityPercentage",
  //   label: "Productividad",
  //   align: "center",
  //   "min-width": 150,
  //   sortable: true,
  //   formatter: (row, column, rowValue) => {
  //     const createElement = thiss.$createElement;
  //     return createElement(ColorsForProductivityAndNonProductivity, {
  //       props: {
  //         row,
  //         column,
  //         rowValue
  //       }
  //     });
  //   }
  //   // formatter: (row) => {
  //   //   return row.OverallProductivityPercentage.toFixed(2) + " %";
  //   // }
  // },

  // {
  //   prop: "RemainingHours",
  //   label: "Horas no productivas",
  //   align: "center",
  //   "min-width": 190,
  //   sortable: true,
  //   formatter: (row, column, rowValue) => {
  //     const createElement = thiss.$createElement;
  //     return createElement(ColorsForProductivityAndNonProductivity, {
  //       props: {
  //         row,
  //         column,
  //         rowValue
  //       }
  //     });
  //   }
  //   //formatter: HyperlinkForModuleVacations
  // }
];

export { columns };
